<template>
    <div class="sd">
        <TopHead name="购物指南" :is-f5="true" share-name="购物指南" share-text="购物场所、免税店等" :share-img="bannerArr.length ? bannerArr[0].imgUrl : ''" :is-share="true" />
        <!--banner轮播-->
        <van-swipe class="my-swipe" :autoplay="3000" lazy-render>
            <van-swipe-item v-for="(item,index) in bannerArr" :key="index" class="p_r" @click="bannerGo(item)">
                <van-image fit="cover" :src="item.imgUrl">
                    <template #loading>
                        <img src="../assets/img/img_loading.png" alt="">
                    </template>
                </van-image>
                <div class="p_a name">
                    {{ item.name }}
                </div>
            </van-swipe-item>
        </van-swipe>
        <!--搜索-->
        <search :is-show="false" />
        <!--tab-->
        <div class="sd_tab_out">
            <!-- <div class="sdt_tab t_a" :class="acTab == 0 ? 'ac' : ''" @click="changeTab(0)">
                商圈
            </div> -->
            <!-- <div class="sdt_cut" /> -->
            <div class="sdt_tab t_a" :class="acTab == 1 ? 'ac' : ''" @click="changeTab(1)">
                购物场所
            </div>
            <div class="sdt_cut" />
            <div class="sdt_tab t_a" :class="acTab == 3 ? 'ac' : ''" @click="changeTab(3)">
                滨海礼物
            </div>
            <div class="sdt_cut" />
            <div class="sdt_tab t_a" :class="acTab == 2 ? 'ac' : ''" @click="changeTab(2)">
                免税店
            </div>
        </div>
        <!--列表-->

        <van-pull-refresh v-if="acTab != 2 && acTab != 3" v-model="loading" @refresh="onRefresh">
            <van-list v-model="loading" :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="onLoad">
                <div v-for="(item,index) in list" :key="index" class="list_item d_f ali_c" @click="goto(item)">
                    <van-image fit="cover" :src="item.coverUrl">
                        <template #loading>
                            <img src="../assets/img/img_loading.png" alt="">
                        </template>
                    </van-image>
                    <div class="flex_1 over_h">
                        <div class="li_ti">
                            {{ item.name }}
                        </div>

                        <div class="rate_out">
                            <template v-if="item.summarizenRating !== null">

                                <img v-for="itm in Math.floor(item.summarizenRating || 0)" src="../assets/img/star_a.png" alt="">
                                <img v-if="Number(item.summarizenRating ? item.summarizenRating.toString().split('.')[1] : 0)>0" src="../assets/img/star_half.png" alt="">
                                <img v-else src="../assets/img/star_dis.png" alt="">
                                <img v-for="itm in (4-Math.floor(item.summarizenRating || 0))" src="../assets/img/star_dis.png" alt="">
                            </template>
                            <span>{{ item.summarizenRating || '暂无评分'}}</span>
                            <span class="ml_22">{{ item.ratingNums }}条评价</span>
                        </div>

                        <div class="tag_out">
                            <div v-for="(it,idx) in item.tagList" :key="idx" class="d_i tags">
                                {{ it.name }}
                            </div>
                        </div>
                        <div class="text_over">
                            {{ item.remark }}
                        </div>
                    </div>
                </div>
            </van-list>
        </van-pull-refresh>

        <!--免税列表-->
        <van-pull-refresh v-if="acTab == 2" v-model="loadingMs" @refresh="onRefreshMs">
            <van-list v-model="loadingMs" :immediate-check="false" :finished="finishedMs" finished-text="没有更多了" @load="onLoadMs">
                <div v-for="(item,index) in listMs" :key="index" class="list_item d_f ali_c" @click="goto(item)">
                    <van-image fit="cover" :src="item.cover">
                        <template #loading>
                            <img src="../assets/img/img_loading.png" alt="">
                        </template>
                    </van-image>
                    <div class="flex_1 over_h">
                        <div class="li_ti">
                            {{ item.name }}
                        </div>

                        <div class="rate_out">
                            <template v-if="item.summarizenRating !== null">

                                <img v-for="itm in Math.floor(item.summarizenRating || 0)" src="../assets/img/star_a.png" alt="">
                                <img v-if="Number(item.summarizenRating ? item.summarizenRating.toString().split('.')[1] : 0)>0" src="../assets/img/star_half.png" alt="">
                                <img v-else src="../assets/img/star_dis.png" alt="">
                                <img v-for="itm in (4-Math.floor(item.summarizenRating || 0))" src="../assets/img/star_dis.png" alt="">
                            </template>
                            <span>{{ item.summarizenRating || '暂无评分'}}</span>
                            <span class="ml_22">{{ item.ratingNums }}条评价</span>
                        </div>

                        <div class="tag_out">
                            <div v-for="(it,idx) in item.tagList" :key="idx" class="d_i tags">
                                {{ it.name }}
                            </div>
                        </div>
                        <div class="text_over">
                            {{ item.remark }}
                        </div>
                    </div>
                </div>
            </van-list>
        </van-pull-refresh>
        <!--滨海礼物-->
        <van-pull-refresh v-if="acTab == 3" v-model="loadingLw" @refresh="onRefreshLw">
            <van-list v-model="loadingLw" :immediate-check="false" :finished="finishedLw" finished-text="没有更多了" @load="onLoadLw">
                <div v-for="(item,index) in listLw" :key="index" class="list_item d_f ali_c" @click="goto(item)">
                    <van-image fit="cover" :src="item.cover">
                        <template #loading>
                            <img src="../assets/img/img_loading.png" alt="">
                        </template>
                    </van-image>
                    <div class="flex_1 over_h">
                        <div class="li_ti">
                            {{ item.name }}
                        </div>

                        <div class="rate_out">
                            <template v-if="item.summarizenRating !== null">
                                <img v-for="itm in Math.floor(item.summarizenRating)" src="../assets/img/star_a.png" alt="">
                                <img v-if="Number(item.summarizenRating ? item.summarizenRating.toString().split('.')[1] : 0)>0" src="../assets/img/star_half.png" alt="">
                                <template v-else>
                                    <img v-if="item.summarizenRating<5" src="../assets/img/star_dis.png" class="hh" alt="">
                                </template>
                                <template v-if="item.summarizenRating<5">
                                    <img v-for="itm in (4-Math.floor(item.summarizenRating))" src="../assets/img/star_dis.png" alt="">
                                </template>
                            </template>
                            <span>{{ item.summarizenRating || '暂无评分'}}</span>
                            <span class="ml_22">{{ item.ratingNums }}条评价</span>
                        </div>

                        <div class="tag_out">
                            <div v-for="(it,idx) in item.tagList" :key="idx" class="d_i tags">
                                {{ it.name }}
                            </div>
                        </div>
                        <div class="text_over">
                            {{ item.remark }}
                        </div>
                    </div>
                </div>
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
import url from '../assets/img/h_bg.png';
export default {
    name: 'ShoppingDirectory',
    data() {
        return {
            rateNum: 3.1,
            src: url,
            acTab: 1,
            refreshing: false,
            loading: true,
            finished: false,
            list: [],
            params: {
                pageIndex: 1,
                pageSize: 10,
                data: {
                    tagCode: '',
                },
            },
            refreshingMs: false,
            loadingMs: true,
            finishedMs: false,
            listMs: [],
            paramsMs: {
                pageIndex: 1,
                pageSize: 10,
                data: {
                    sellerTypeCode: 'seller_type_dutyfree',
                },
            },
            refreshingLw: false,
            loadingLw: true,
            finishedLw: false,
            listLw: [],
            paramsLw: {
                pageIndex: 1,
                pageSize: 10,
                data: {
                    commodityTypeCode: 'liw',
                },
            },
            bannerArr: [],
        };
    },
    created() {
        this.getBanner();
        this.listLoad();
        // this.listLoadMs();
    },
    methods: {
        // 跳转到内页
        goto(row) {
            let id = row.cbdId || row.sellerId;
            let cId = row.commodityId;
            this.$router.push(
                '/shoppingInner?id=' + id + '&tab=' + this.acTab + '&cId=' + cId
            );
        },
        //商圈和购物场所属于商圈
        listLoad() {
            this.loading = true;
            this.params.data.tagCode = this.acTab == 0 ? 'sq' : 'gwcs';
            this.$api.getCbdList(this.params).then(res => {
                this.loading = false;
                if (this.refreshing) {
                    this.refreshing = false;
                }
                if (res.data.recordCount) {
                    this.list = this.list.concat(
                        JSON.parse(JSON.stringify(res.data.rows))
                    );
                }
                let list = res.data.rows;
                if (!list || list.length < this.params.pageSize) {
                    this.finished = true;
                }
            });
        },
        onRefresh() {
            this.list = [];
            this.finished = false;
            this.params.pageIndex = 1;
            this.listLoad();
        },
        onLoad() {
            let me = this;
            let page = me.params.pageIndex;
            page = page ? page + 1 : 1;
            this.params.pageIndex = page;
            this.listLoad();
        },
        //免税店
        listLoadMs() {
            this.loadingMs = true;
            this.$api.getSellerList(this.paramsMs).then(res => {
                this.loadingMs = false;
                if (this.refreshingMs) {
                    this.refreshingMs = false;
                }
                if (res.data.recordCount) {
                    this.listMs = this.listMs.concat(
                        JSON.parse(JSON.stringify(res.data.rows))
                    );
                }
                let list = res.data.rows;
                if (!list || list.length < this.paramsMs.pageSize) {
                    this.finishedMs = true;
                }
            });
        },
        //礼物
        listLoadLw() {
            this.loadingLw = true;
            this.$api.getCommodityList(this.paramsLw).then(res => {
                this.loadingLw = false;
                if (this.refreshingLw) {
                    this.refreshingLw = false;
                }
                if (res.data.recordCount) {
                    this.listLw = this.listLw.concat(
                        JSON.parse(JSON.stringify(res.data.rows))
                    );
                }
                let list = res.data.rows;
                if (!list || list.length < this.paramsLw.pageSize) {
                    this.finishedLw = true;
                }
            });
        },
        onRefreshMs() {
            this.listMs = [];
            this.finishedMs = false;
            this.paramsMs.pageIndex = 1;
            this.listLoadMs();
        },
        onRefreshLw() {
            this.listLw = [];
            this.finishedLw = false;
            this.paramsLw.pageIndex = 1;
            this.listLoadLw();
        },
        onLoadMs() {
            let me = this;
            let page = me.paramsMs.pageIndex;
            page = page ? page + 1 : 1;
            this.paramsMs.pageIndex = page;
            this.listLoadMs();
        },
        //切换他爸
        changeTab(num) {
            this.acTab = num;
            if (num == 2) {
                this.onRefreshMs();
            }
            if (num == 3) {
                this.onRefreshLw();
            } else {
                this.onRefresh();
            }
        },

        bannerGo(row) {
            if (row.interlinkage) {
                if (row.backRequired) {
                    window.location.href = row.interlinkage;
                } else {
                    this.$router.push(row.interlinkage);
                }
            }
        },
        //获取banner
        getBanner() {
            this.$api.getBanner({ position: 9 }).then(res => {
                this.bannerArr = res.data;
            });
        },
    },
};
</script>

<style scoped lang="scss">
.list_item {
    font-size: 28px;
    font-weight: 500;
    color: #6e6e6e;
    margin-bottom: 20px;
    .tags {
        height: 40px;
        line-height: 40px;
        padding: 0 8px;
        background: #e9edff;
        border-radius: 5px;
        font-size: 26px;
        font-weight: 500;
        color: #4087f5;
        text-align: center;
        margin-right: 15px;
        margin-bottom: 25px;
    }
    .rate_out {
        margin-bottom: 30px;
        font-size: 24px;
        font-weight: 500;
        color: #3e3e3e;
        img {
            width: 26px;
            margin-right: 7px;
        }
        span {
            position: relative;
            top: -4px;
            margin-left: 3px;
        }
    }
    .li_ti {
        margin-bottom: 32px;
        font-size: 34px;
        font-weight: bold;
        color: #000000;
    }
    .van-image {
        width: 259px;
        height: 242px;
        overflow: hidden;
        border-radius: 5px;
        margin-right: 30px;
    }
    padding: 11px 15px 27px;
    background: #ffffff;
    border-radius: 5px;
}
.sd_tab_out {
    .sdt_cut {
        width: 1px;
        height: 26px;
        background: #c0c0c0;
        margin: 0 29.5px;
    }
    .sdt_tab {
        width: 114px;
        &.ac {
            width: 154px;
            color: #ffffff;
            height: 48px;
            background: #4c90f1;
            border-radius: 24px;
            line-height: 48px;
        }
        font-size: 28px;
        font-weight: 500;
        color: #3e3e3e;
    }
    > div {
        display: inline-block;
    }
    margin: 30px 11px 28px 11px;
}
.my-swipe {
    .van-swipe-item {
        .name {
            left: 0;
            bottom: 0;
            height: 46px;
            background: rgba(0, 0, 0, 0.45);
            padding: 0 25px;
            line-height: 46px;
            font-size: 26px;
            font-weight: 400;
            color: #ffffff;
            width: 100%;
            box-sizing: border-box;
        }
        height: 280px;
        border-radius: 10px;
        overflow: hidden;
    }
    margin-bottom: 20px;
}
.sd {
    height: 100vh;
    box-sizing: border-box;
    padding: 100px 25px 25px;
    background-color: #f5f5f5;
}
</style>
